(function () {
  'use strict';

  if (window.MRSetBuilderBootstrapped) {
    if (window.MRSetBuilderInit) window.MRSetBuilderInit(document);
    return;
  }

  window.MRSetBuilderBootstrapped = true;

  var ROOT_SELECTOR = '[data-mr-set-builder]';
  var CONTROL_SELECTOR = [
    '[data-mr-name-input]',
    '[data-mr-no-name]',
    '[data-mr-product-option]',
    '[data-mr-font-id]',
    '[data-mr-yarn-id]',
    '[data-mr-icon-id]'
  ].join(',');

  function initAll(context) {
    var scope = context && context.querySelectorAll ? context : document;
    if (scope.matches && scope.matches(ROOT_SELECTOR)) initBuilder(scope);
    scope.querySelectorAll(ROOT_SELECTOR).forEach(initBuilder);
  }

  function initBuilder(root) {
    if (!root || root.dataset.mrSetInitialized === 'true') return;
    root.dataset.mrSetInitialized = 'true';

    var tabs = Array.from(root.querySelectorAll('[data-mr-set-tab]'));
    var panels = Array.from(root.querySelectorAll('[data-mr-set-panel]'));
    var progress = root.querySelector('[data-mr-set-progress]');
    var launcher = root.querySelector('[data-mr-set-launcher]');
    var launcherLabel = root.querySelector('[data-mr-set-launcher-label]');
    var launcherCount = root.querySelector('[data-mr-set-launcher-count]');
    var dialog = root.querySelector('[data-mr-set-dialog]');
    var modalCount = root.querySelector('[data-mr-set-modal-count]');
    var pickerButtons = Array.from(root.querySelectorAll('[data-mr-set-pick]'));
    var modalActionButton = root.querySelector('[data-mr-set-modal-action]');
    var modalActionLabel = root.querySelector('[data-mr-set-modal-action-label]');
    var activePanel = panels.find(function (panel) { return !panel.hidden; }) || panels[0] || null;
    var copySourcePanel = null;
    var selectedPicker = null;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var productCount = Math.max(0, Number(root.dataset.productCount) || tabs.length);
    var railColumns = Math.max(1, Number(root.dataset.railColumns) || 3);
    if (productCount === 1) railColumns = 1;
    if (productCount === 2 || productCount === 4) railColumns = 2;
    if (productCount >= 3 && productCount <= 9 && productCount !== 4) railColumns = 3;
    var personalizeLabel = root.dataset.personalizeLabel || 'Personalize';
    var cartRefreshTimer = null;
    var cartUpdateUnsubscribe = null;
    var tiers = getDiscountTiers(root);
    var cartState = {
      itemCount: Math.max(0, Number(root.dataset.cartItemCount) || 0),
      totalPrice: Math.max(0, Number(root.dataset.cartTotal) || 0),
      currency: root.dataset.cartCurrency || 'USD'
    };
    var freeShippingThreshold = getFreeShippingThreshold(root);

    panels.forEach(function (panel) {
      preparePanel(panel);
      observeCartSuccess(panel, onCartSuccess);
    });

    function setActive(tab, options) {
      options = options || {};
      var nextPanel = root.querySelector('#' + escapeId(tab.dataset.panelId));
      if (!nextPanel) return null;
      var previousPanel = activePanel;
      var savedScrollX = window.scrollX;
      var savedScrollY = window.scrollY;

      if (nextPanel !== activePanel) {
        if (previousPanel && previousPanel.dataset.mrSetTouched === 'true') {
          copySourcePanel = previousPanel;
        }

        tabs.forEach(function (item) {
          var selected = item === tab;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-selected', selected ? 'true' : 'false');
          item.tabIndex = selected ? 0 : -1;
          var state = item.querySelector('[data-mr-set-tab-state]');
          if (state && !item.classList.contains('is-added')) {
            state.textContent = selected ? 'Selected' : 'Choose';
          }
        });

        panels.forEach(function (panel) {
          var selected = panel === nextPanel;
          panel.hidden = !selected;
          panel.classList.toggle('is-active', selected);
        });

        activePanel = nextPanel;
        clearCopyWarnings(activePanel);

        var optionColumn = activePanel.querySelector('[data-mr-option-column]');
        if (optionColumn) optionColumn.scrollTop = 0;

        if (window.MRAppleProductInit) window.MRAppleProductInit(activePanel);
        showProductMedia(activePanel);
        window.dispatchEvent(new Event('resize'));

        if (
          options.autoCopy !== false &&
          copySourcePanel &&
          copySourcePanel !== activePanel &&
          copySourcePanel.dataset.mrSetTouched === 'true'
        ) {
          copyIntoPanel(copySourcePanel, activePanel, {
            navigate: false,
            preservePosition: true,
            scrollX: savedScrollX,
            scrollY: savedScrollY
          });
        } else if (options.preservePosition !== false) {
          restorePassiveView(activePanel, savedScrollX, savedScrollY);
        }
      }

      if (options.scroll !== false) {
        tab.scrollIntoView({
          behavior: reducedMotion ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
      if (options.preservePosition !== false) {
        restoreWindowPosition(savedScrollX, savedScrollY);
      }
      return nextPanel;
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        setActive(tab);
      });

      tab.addEventListener('keydown', function (event) {
        var nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = Math.min(tabs.length - 1, index + 1);
        if (event.key === 'ArrowLeft') nextIndex = Math.max(0, index - 1);
        if (event.key === 'ArrowDown') nextIndex = Math.min(tabs.length - 1, index + railColumns);
        if (event.key === 'ArrowUp') nextIndex = Math.max(0, index - railColumns);
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (nextIndex === index) return;
        event.preventDefault();
        tabs[nextIndex].focus();
        setActive(tabs[nextIndex]);
      });
    });

    root.addEventListener('input', markTouched, true);
    root.addEventListener('change', markTouched, true);
    root.addEventListener('click', markTouched, true);

    function markTouched(event) {
      var control = event.target.closest && event.target.closest(CONTROL_SELECTOR);
      if (!control) return;
      var panel = control.closest('[data-mr-set-panel]');
      if (panel) panel.dataset.mrSetTouched = 'true';
    }

    if (launcher && dialog) {
      launcher.addEventListener('click', function () {
        openProgressDialog([]);
        refreshCartData().then(function () {
          updateProgressUI();
        }).catch(function () {});
      });
    }

    if (dialog) {
      dialog.addEventListener('close', function () {
        if (launcher) launcher.setAttribute('aria-expanded', 'false');
      });
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) closeDialog(dialog);
      });
    }

    pickerButtons.forEach(function (picker) {
      picker.addEventListener('click', function () {
        selectedPicker = picker;
        pickerButtons.forEach(function (item) {
          var selected = item === picker;
          item.classList.toggle('is-selected', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        updateModalAction();
      });
    });

    if (modalActionButton) {
      modalActionButton.addEventListener('click', function () {
        if (!selectedPicker) return;
        var targetTab = tabs.find(function (tab) { return tab.dataset.panelId === selectedPicker.dataset.panelId; });
        if (!targetTab) return;

        var sourcePanel = activePanel || copySourcePanel;
        closeDialog(dialog);
        var targetPanel = setActive(targetTab, {
          autoCopy: false,
          scroll: false,
          preservePosition: false
        });
        if (!targetPanel) return;

        window.setTimeout(function () {
          if (sourcePanel && sourcePanel !== targetPanel) {
            copyIntoPanel(sourcePanel, targetPanel, { navigate: true });
            return;
          }

          var addButton = targetPanel.querySelector('[data-mr-add-button]');
          if (addButton && addButton.disabled) {
            var incompleteCard = findFirstIncompleteCard(targetPanel);
            if (incompleteCard) {
              showCopyWarning({
                element: incompleteCard,
                message: 'Please complete this option before adding the product to your cart.'
              });
              moveTo(incompleteCard, firstFocusable(incompleteCard), reducedMotion);
              return;
            }
          }
          if (addButton) {
            moveTo(addButton, addButton, reducedMotion);
          } else {
            targetPanel.scrollIntoView({
              behavior: reducedMotion ? 'auto' : 'smooth',
              block: 'start',
              inline: 'nearest'
            });
          }
        }, reducedMotion ? 0 : 180);
      });
    }

    function updateModalAction() {
      if (!modalActionButton) return;
      modalActionButton.disabled = !selectedPicker;
      if (modalActionLabel) {
        modalActionLabel.textContent = selectedPicker ? personalizeLabel : 'Select an item first';
      }
    }

    function resetModalSelection() {
      selectedPicker = null;
      pickerButtons.forEach(function (picker) {
        picker.classList.remove('is-selected');
        picker.setAttribute('aria-pressed', 'false');
      });
      updateModalAction();
    }

    function copyIntoPanel(sourcePanel, targetPanel, options) {
      options = options || {};
      clearCopyWarnings(targetPanel);
      return copyPersonalization(sourcePanel, targetPanel).then(function (result) {
        targetPanel.dataset.mrSetTouched = 'true';
        showProductMedia(targetPanel);
        var destination = result.firstMismatch;

        if (!destination) {
          var addButton = targetPanel.querySelector('[data-mr-add-button]');
          if (addButton && addButton.disabled) {
            var incompleteCard = findFirstIncompleteCard(targetPanel);
            if (incompleteCard) {
              destination = {
                element: incompleteCard,
                message: 'Please complete this option before adding the product to your cart.'
              };
            }
          }
        }

        if (destination) {
          showCopyWarning(destination);
          if (options.navigate === true) {
            moveTo(destination.element, destination.focus, reducedMotion);
          } else {
            restorePassiveView(
              targetPanel,
              Number.isFinite(options.scrollX) ? options.scrollX : window.scrollX,
              Number.isFinite(options.scrollY) ? options.scrollY : window.scrollY
            );
          }
          return result;
        }

        var button = targetPanel.querySelector('[data-mr-add-button]');
        if (options.navigate === true) {
          if (button) moveTo(button, button, reducedMotion);
        } else {
          restorePassiveView(
            targetPanel,
            Number.isFinite(options.scrollX) ? options.scrollX : window.scrollX,
            Number.isFinite(options.scrollY) ? options.scrollY : window.scrollY
          );
        }
        return result;
      });
    }

    function onCartSuccess(panel) {
      var previousState = getProgressState(cartState.itemCount, tiers);
      var previousCartTotal = cartState.totalPrice;
      panel.dataset.mrSetAdded = 'true';
      panel.dataset.mrSetTouched = 'true';
      copySourcePanel = panel;

      var tab = tabs.find(function (item) { return item.dataset.panelId === panel.id; });
      if (tab) {
        tab.classList.add('is-added');
        tab.dataset.cartQuantity = String((Number(tab.dataset.cartQuantity) || 0) + 1);
        var state = tab.querySelector('[data-mr-set-tab-state]');
        if (state) state.textContent = 'Added';
      }

      refreshCartData().then(function () {
        var currentState = updateProgressUI();
        openProgressDialog(getUnlockedRewards(
          previousState,
          currentState,
          previousCartTotal,
          cartState.totalPrice,
          freeShippingThreshold
        ));
      }).catch(function () {
        cartState.itemCount += 1;
        root.dataset.cartItemCount = String(cartState.itemCount);
        var currentState = updateProgressUI();
        openProgressDialog(getUnlockedRewards(
          previousState,
          currentState,
          previousCartTotal,
          cartState.totalPrice,
          freeShippingThreshold
        ));
      });
    }

    function updateProgressUI() {
      var state = getProgressState(cartState.itemCount, tiers);
      updateProgress(root, progress, launcherLabel, launcherCount, modalCount, state, tiers);
      updateFreeShipping(root, cartState, freeShippingThreshold);
      updateStatusItems(root, tabs);
      return state;
    }

    function openProgressDialog(unlockedRewards) {
      if (!dialog) return;
      resetModalSelection();
      updateProgressUI();
      renderUnlock(dialog, unlockedRewards, reducedMotion);
      if (!dialog.open) {
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
      }
      if (launcher) launcher.setAttribute('aria-expanded', 'true');
    }

    function refreshCartData() {
      return fetchCart().then(function (cart) {
        applyCartData(cart);
        return cart;
      });
    }

    function applyCartData(cart) {
      if (!cart || typeof cart.item_count === 'undefined') return false;
      cartState.itemCount = Math.max(0, Number(cart.item_count) || 0);
      cartState.totalPrice = Math.max(0, Number(cart.total_price) || 0);
      cartState.currency = cart.currency || cartState.currency;
      root.dataset.cartItemCount = String(cartState.itemCount);
      root.dataset.cartTotal = String(cartState.totalPrice);
      syncProductCartState(tabs, cart.items || []);
      updateProgressUI();
      return true;
    }

    function scheduleCartRefresh(delay) {
      window.clearTimeout(cartRefreshTimer);
      cartRefreshTimer = window.setTimeout(function () {
        refreshCartData().catch(function () {});
      }, typeof delay === 'number' ? delay : 420);
    }

    function onThemeCartUpdated() {
      scheduleCartRefresh(420);
    }

    function onWindowFocus() {
      scheduleCartRefresh(0);
    }

    function onVisibilityChange() {
      if (!document.hidden) scheduleCartRefresh(0);
    }

    document.addEventListener('cartUpdated', onThemeCartUpdated);
    window.addEventListener('focus', onWindowFocus);
    document.addEventListener('visibilitychange', onVisibilityChange);

    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        cartUpdateUnsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
          if (!event || !applyCartData(event.cartData)) scheduleCartRefresh(80);
        });
      }
    } catch (error) {
      cartUpdateUnsubscribe = null;
    }

    document.addEventListener('shopify:section:unload', function onSectionUnload(event) {
      if (event.target !== root && !(event.target && event.target.contains && event.target.contains(root))) return;
      window.clearTimeout(cartRefreshTimer);
      document.removeEventListener('cartUpdated', onThemeCartUpdated);
      window.removeEventListener('focus', onWindowFocus);
      document.removeEventListener('visibilitychange', onVisibilityChange);
      if (typeof cartUpdateUnsubscribe === 'function') cartUpdateUnsubscribe();
      document.removeEventListener('shopify:section:unload', onSectionUnload);
    });

    if (activePanel) showProductMedia(activePanel);
    updateProgressUI();
  }

  function preparePanel(panel) {
    var optionColumn = panel.querySelector('[data-mr-option-column]');
    var reviewCard = panel.querySelector('.mr-apple-product__review-card');
    var reviewStage = panel.querySelector('.mr-apple-product__review-stage');
    if (optionColumn && reviewCard && !reviewCard.classList.contains('is-mr-set-inline')) {
      reviewCard.classList.add('is-mr-set-inline');
      optionColumn.appendChild(reviewCard);
      if (reviewStage) reviewStage.classList.add('is-mr-set-relocated');
    }

    var displayTitle = panel.dataset.productTitle || '';
    if (displayTitle) {
      panel.querySelectorAll('.mr-apple-product__title, .mr-standard-product__title').forEach(function (title) {
        title.textContent = displayTitle;
      });
    }

    var customizer = panel.querySelector('.mr-apple-product[data-mr-layer-editing="false"]');
    if (customizer) {
      var nameSubtitle = customizer.querySelector('[data-mr-card="name"] .mr-apple-product__card-subtitle');
      var iconSubtitle = customizer.querySelector('[data-mr-card="icons"] .mr-apple-product__card-subtitle');
      if (nameSubtitle && nameSubtitle.textContent.trim() === 'You can drag the name on the preview after typing it.') {
        nameSubtitle.textContent = 'Your name uses this product’s saved placement.';
      }
      if (iconSubtitle && iconSubtitle.textContent.trim() === 'Optional. Selected icons can be dragged on the preview.') {
        iconSubtitle.textContent = 'Optional. Icons use this product’s saved placement.';
      }
    }

    var form = panel.querySelector('[data-mr-product-form]');
    if (form && form.dataset.mrSetObserved !== 'true') {
      form.dataset.mrSetObserved = 'true';
      form.addEventListener('submit', function () {
        panel.dataset.mrSetAwaitingAdd = 'true';
      });
    }
  }

  function showProductMedia(panel) {
    if (!panel) return;
    var previewCard = panel.querySelector('.mr-apple-product__preview-card');
    var previewBoard = panel.querySelector('[data-mr-preview-board]');
    var mediaGallery = panel.querySelector('[data-mr-product-media-gallery]');
    if (!previewCard || !previewBoard || !mediaGallery) return;

    previewCard.classList.add('is-product-media-mode');
    previewBoard.hidden = true;
    mediaGallery.hidden = false;

    var mediaToggle = panel.querySelector('[data-mr-media-toggle]');
    var mediaToggleLabel = panel.querySelector('[data-mr-media-toggle-label]');
    var mobileMediaToggle = panel.querySelector('[data-mr-mobile-media-toggle]');
    var mobileMediaToggleLabel = panel.querySelector('[data-mr-mobile-media-toggle-label]');
    if (mediaToggle) mediaToggle.setAttribute('aria-pressed', 'true');
    if (mediaToggleLabel) mediaToggleLabel.textContent = 'View custom preview';
    if (mobileMediaToggle) mobileMediaToggle.setAttribute('aria-pressed', 'true');
    if (mobileMediaToggleLabel) mobileMediaToggleLabel.textContent = 'Custom preview';
  }

  function restorePassiveView(panel, scrollX, scrollY) {
    if (!panel) return;
    showProductMedia(panel);
    var optionColumn = panel.querySelector('[data-mr-option-column]');
    if (optionColumn) optionColumn.scrollTop = 0;
    window.dispatchEvent(new Event('resize'));
    restoreWindowPosition(scrollX, scrollY);
  }

  function restoreWindowPosition(scrollX, scrollY) {
    var left = Number.isFinite(scrollX) ? scrollX : window.scrollX;
    var top = Number.isFinite(scrollY) ? scrollY : window.scrollY;
    window.scrollTo(left, top);
    requestAnimationFrame(function () {
      window.scrollTo(left, top);
      requestAnimationFrame(function () {
        window.scrollTo(left, top);
      });
    });
  }

  async function copyPersonalization(sourcePanel, targetPanel) {
    var sourceRoot = sourcePanel.querySelector('.mr-apple-product');
    var targetRoot = targetPanel.querySelector('.mr-apple-product');
    var result = { copied: 0, skipped: 0, firstMismatch: null };

    function mismatch(element, message, focus) {
      result.skipped += 1;
      if (!result.firstMismatch) {
        result.firstMismatch = {
          element: element || targetPanel,
          focus: focus || firstFocusable(element),
          message: message
        };
      }
    }

    if (!sourceRoot || !targetRoot || targetRoot.classList.contains('mr-apple-product--fallback')) {
      mismatch(
        targetPanel.querySelector('[data-mr-add-button]') || targetPanel,
        'This product uses a different customization setup. Please choose its available options.'
      );
      return result;
    }

    var selectedOptions = Array.from(sourceRoot.querySelectorAll('[data-mr-product-option][aria-pressed="true"]'));
    for (var optionIndex = 0; optionIndex < selectedOptions.length; optionIndex += 1) {
      var sourceOption = selectedOptions[optionIndex];
      var optionName = sourceOption.dataset.mrProductOption;
      var targetOption = findByData(
        targetRoot,
        'mrProductOption',
        optionName,
        'mrProductValue',
        sourceOption.dataset.mrProductValue
      );
      if (targetOption) {
        if (targetOption.getAttribute('aria-pressed') !== 'true') targetOption.click();
        result.copied += 1;
        await nextPaint();
      } else {
        var optionCard = Array.from(targetRoot.querySelectorAll('[data-mr-product-option-card]')).find(function (card) {
          return String(card.dataset.mrProductOptionCard || '') === String(optionName || '');
        }) || targetRoot.querySelector('[data-mr-product-option-card]');
        mismatch(
          optionCard,
          'This option is different for this product. Please choose an available value.',
          firstFocusable(optionCard)
        );
      }
    }

    var sourceNoName = sourceRoot.querySelector('[data-mr-no-name]');
    var targetNoName = targetRoot.querySelector('[data-mr-no-name]');
    if (sourceNoName) {
      if (targetNoName) {
        if (targetNoName.checked !== sourceNoName.checked) {
          targetNoName.checked = sourceNoName.checked;
          dispatch(targetNoName, 'change');
          await nextPaint();
        }
        result.copied += 1;
      } else {
        mismatch(targetRoot.querySelector('[data-mr-card="name"]'), 'Please choose the name option for this product.');
      }
    }

    var sourceName = sourceRoot.querySelector('[data-mr-name-input]');
    var targetName = targetRoot.querySelector('[data-mr-name-input]');
    if (sourceName && (!sourceNoName || !sourceNoName.checked)) {
      if (targetName) {
        targetName.value = sourceName.value;
        dispatch(targetName, 'input');
        result.copied += 1;
        await nextPaint();
      } else {
        mismatch(targetRoot.querySelector('[data-mr-card="name"]'), 'Please enter the name for this product.');
      }
    }

    var selectedFont = sourceRoot.querySelector('[data-mr-font-id][aria-pressed="true"]');
    if (selectedFont) {
      var targetFont = findByData(targetRoot, 'mrFontId', selectedFont.dataset.mrFontId);
      if (targetFont) {
        if (targetFont.getAttribute('aria-pressed') !== 'true') targetFont.click();
        result.copied += 1;
        await nextPaint();
      } else {
        var fontField = targetRoot.querySelector('[data-mr-font-field]') || targetRoot.querySelector('[data-mr-card="name"]');
        mismatch(fontField, 'That font is not available for this product. Please choose another font.');
      }
    }

    var multiGroups = [
      {
        selector: '[data-mr-yarn-id]',
        key: 'mrYarnId',
        card: '[data-mr-card="yarn"]',
        message: 'That color is not available for this product. Please choose another color.'
      },
      {
        selector: '[data-mr-icon-id]',
        key: 'mrIconId',
        card: '[data-mr-card="icons"]',
        message: 'One or more icons are not available for this product. Please choose another icon.'
      }
    ];

    for (var multiIndex = 0; multiIndex < multiGroups.length; multiIndex += 1) {
      var group = multiGroups[multiIndex];
      var sourceValues = Array.from(sourceRoot.querySelectorAll(group.selector + '[aria-pressed="true"]')).map(function (node) {
        return node.dataset[group.key];
      });
      var targetSelected = Array.from(targetRoot.querySelectorAll(group.selector + '[aria-pressed="true"]'));
      for (var clearIndex = 0; clearIndex < targetSelected.length; clearIndex += 1) {
        targetSelected[clearIndex].click();
        await nextPaint();
      }
      for (var valueIndex = 0; valueIndex < sourceValues.length; valueIndex += 1) {
        var targetChoice = findByData(targetRoot, group.key, sourceValues[valueIndex]);
        if (targetChoice) {
          targetChoice.click();
          await nextPaint();
          if (targetChoice.getAttribute('aria-pressed') === 'true') {
            result.copied += 1;
          } else {
            mismatch(targetRoot.querySelector(group.card), group.message, targetChoice);
          }
        } else {
          mismatch(targetRoot.querySelector(group.card), group.message);
        }
      }
    }

    window.dispatchEvent(new Event('resize'));
    return result;
  }

  function findFirstIncompleteCard(panel) {
    var cards = Array.from(panel.querySelectorAll('[data-mr-card]')).filter(function (card) {
      return !card.hidden && card.dataset.mrCard !== 'review';
    });

    for (var index = 0; index < cards.length; index += 1) {
      var card = cards[index];
      if (card.matches('[data-mr-product-option-card]') && !card.querySelector('[data-mr-product-option][aria-pressed="true"]')) {
        return card;
      }
      if (card.dataset.mrCard === 'name' && card.dataset.mrRequired === 'true') {
        var noName = card.querySelector('[data-mr-no-name]');
        var name = card.querySelector('[data-mr-name-input]');
        if ((!noName || !noName.checked) && (!name || !name.value.trim())) return card;
      }
      if (card.dataset.mrCard === 'yarn' && card.dataset.mrRequired === 'true' && !card.querySelector('[data-mr-yarn-id][aria-pressed="true"]')) {
        return card;
      }
      if (card.dataset.mrCard === 'icons' && card.dataset.mrRequired === 'true' && !card.querySelector('[data-mr-icon-id][aria-pressed="true"]')) {
        return card;
      }
      if (card.classList.contains('is-locked')) return card;
    }
    return panel.querySelector('[data-mr-card="review"]');
  }

  function showCopyWarning(destination) {
    if (!destination || !destination.element) return;
    var card = destination.element.closest('[data-mr-card]') || destination.element;
    card.classList.add('has-copy-warning');
    var warning = document.createElement('p');
    warning.className = 'mr-set-builder__choice-warning';
    warning.dataset.mrSetCopyWarning = 'true';
    warning.setAttribute('role', 'alert');
    warning.textContent = destination.message || 'Please choose an option for this product.';
    card.appendChild(warning);
  }

  function clearCopyWarnings(panel) {
    if (!panel) return;
    panel.querySelectorAll('[data-mr-set-copy-warning]').forEach(function (warning) { warning.remove(); });
    panel.querySelectorAll('.has-copy-warning').forEach(function (card) { card.classList.remove('has-copy-warning'); });
  }

  function moveTo(element, focusTarget, reducedMotion) {
    if (!element) return;
    var card = element.closest('[data-mr-card]') || element;
    card.scrollIntoView({
      behavior: reducedMotion ? 'auto' : 'smooth',
      block: 'center',
      inline: 'nearest'
    });
    var focus = focusTarget || firstFocusable(card);
    if (focus && typeof focus.focus === 'function') {
      window.setTimeout(function () {
        focus.focus({ preventScroll: true });
      }, reducedMotion ? 0 : 360);
    }
  }

  function firstFocusable(element) {
    if (!element || !element.querySelector) return null;
    return Array.from(element.querySelectorAll('button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).find(function (node) {
      return !node.hidden;
    }) || null;
  }

  function observeCartSuccess(panel, callback) {
    var message = panel.querySelector('[data-mr-message]');
    if (!message || !window.MutationObserver) return;
    var observer = new MutationObserver(function () {
      if (message.hidden || !message.classList.contains('is-success')) return;
      if (panel.dataset.mrSetAwaitingAdd !== 'true') return;
      panel.dataset.mrSetAwaitingAdd = 'false';
      callback(panel);
    });
    observer.observe(message, { attributes: true, childList: true, characterData: true, subtree: true });
  }

  function getDiscountTiers(root) {
    var tiers = [];
    for (var index = 1; index <= 3; index += 1) {
      if (root.getAttribute('data-tier-' + index + '-enabled') !== 'true') continue;
      var quantity = Number(root.getAttribute('data-tier-' + index + '-quantity'));
      var percent = Number(root.getAttribute('data-tier-' + index + '-percent'));
      if (!quantity || !percent) continue;
      var existing = tiers.find(function (tier) { return tier.quantity === quantity; });
      if (existing) existing.percent = Math.max(existing.percent, percent);
      else tiers.push({ quantity: quantity, percent: percent });
    }
    return tiers.sort(function (a, b) { return a.quantity - b.quantity; });
  }

  function getProgressState(itemCount, tiers) {
    var added = Math.max(0, Number(itemCount) || 0);
    var currentTier = null;
    var tierIndex = -1;
    tiers.forEach(function (tier, index) {
      if (added >= tier.quantity) {
        currentTier = tier;
        tierIndex = index;
      }
    });
    var nextTier = tiers.find(function (tier) { return added < tier.quantity; }) || null;
    return {
      added: added,
      currentTier: currentTier,
      nextTier: nextTier,
      tierIndex: tierIndex
    };
  }

  function updateProgress(root, progress, launcherLabel, launcherCount, modalCount, state, tiers) {
    var itemLabel = state.added === 1 ? 'item' : 'items';
    if (progress) progress.textContent = state.added + ' ' + itemLabel + ' in cart';
    if (launcherCount) launcherCount.textContent = String(state.added);
    if (modalCount) modalCount.textContent = state.added + ' ' + itemLabel + ' in your cart';

    if (launcherLabel) {
      var showDiscountInLauncher = root.dataset.discountProgress === 'true' && tiers.length > 0;
      if (showDiscountInLauncher && state.nextTier) {
        var launcherRemaining = state.nextTier.quantity - state.added;
        launcherLabel.textContent = launcherRemaining + ' more to unlock ' + state.nextTier.percent + '% off';
      } else if (showDiscountInLauncher && state.currentTier) {
        launcherLabel.textContent = state.currentTier.percent + '% off unlocked';
      } else {
        launcherLabel.textContent = 'View your matching set';
      }
    }

    var status = root.querySelector('[data-mr-set-tier-status]');
    var next = root.querySelector('[data-mr-set-tier-next]');
    var track = root.querySelector('[data-mr-set-tier-track]');
    var fill = root.querySelector('[data-mr-set-tier-fill]');
    var milestoneWrap = root.querySelector('[data-mr-set-tier-milestones]');
    if (!track || root.dataset.discountProgress !== 'true' || !tiers.length) return;

    var maximum = tiers[tiers.length - 1].quantity;
    var percentage = Math.min(100, (state.added / maximum) * 100);
    track.setAttribute('aria-valuemax', String(maximum));
    track.setAttribute('aria-valuenow', String(Math.min(state.added, maximum)));
    if (fill) fill.style.transform = 'scaleX(' + (percentage / 100) + ')';
    if (status) status.textContent = state.currentTier
      ? state.currentTier.percent + '% off unlocked'
      : 'No discount unlocked yet';

    if (next) {
      if (state.nextTier) {
        var remaining = state.nextTier.quantity - state.added;
        next.textContent = 'Add ' + remaining + ' more ' + (remaining === 1 ? 'item' : 'items') + ' to unlock ' + state.nextTier.percent + '% off';
      } else if (state.currentTier) {
        next.textContent = 'Best offer unlocked';
      } else {
        next.textContent = '';
      }
    }

    if (milestoneWrap && milestoneWrap.dataset.rendered !== 'true') {
      milestoneWrap.dataset.rendered = 'true';
      tiers.forEach(function (tier) {
        var marker = document.createElement('span');
        marker.style.left = Math.min(100, (tier.quantity / maximum) * 100) + '%';
        marker.textContent = tier.quantity + ' · ' + tier.percent + '%';
        milestoneWrap.appendChild(marker);
      });
    }
  }

  function updateStatusItems(root, tabs) {
    root.querySelectorAll('[data-mr-set-status-item]').forEach(function (item) {
      var tab = tabs.find(function (candidate) { return candidate.dataset.panelId === item.dataset.panelId; });
      var quantity = tab ? Math.max(0, Number(tab.dataset.cartQuantity) || 0) : 0;
      var added = quantity > 0;
      item.classList.toggle('is-added', added);
      item.dataset.cartQuantity = String(quantity);
      var text = item.querySelector('[data-mr-set-status-text]');
      var pickLabel = item.querySelector('[data-mr-set-pick-label]');
      if (text) text.textContent = added ? 'In cart · ' + quantity : 'Not in cart yet';
      if (pickLabel) pickLabel.textContent = added ? 'Add another' : 'Add';
    });
  }

  function updateFreeShipping(root, cartState, threshold) {
    var section = root.querySelector('[data-mr-set-shipping]');
    if (!section || root.dataset.freeShippingEnabled !== 'true' || !threshold) return;

    section.hidden = false;
    var track = section.querySelector('[data-mr-set-shipping-track]');
    var fill = section.querySelector('[data-mr-set-shipping-fill]');
    var status = section.querySelector('[data-mr-set-shipping-status]');
    var next = section.querySelector('[data-mr-set-shipping-next]');
    var reached = cartState.totalPrice >= threshold;
    var percentage = Math.min(1, cartState.totalPrice / threshold);

    if (track) {
      track.setAttribute('aria-valuemax', String(threshold));
      track.setAttribute('aria-valuenow', String(Math.min(cartState.totalPrice, threshold)));
    }
    if (fill) fill.style.transform = 'scaleX(' + percentage + ')';
    if (status) status.textContent = reached ? 'Free shipping unlocked' : 'Free shipping';
    if (next) {
      next.textContent = reached
        ? ''
        : 'Spend ' + formatMoney(threshold - cartState.totalPrice, cartState.currency) + ' more to unlock free shipping.';
    }
  }

  function renderUnlock(dialog, rewards, reducedMotion) {
    if (!dialog) return;
    var unlock = dialog.querySelector('[data-mr-set-unlock]');
    if (!unlock) return;
    dialog.classList.remove('is-celebrating');
    if (!rewards || !rewards.length) {
      unlock.hidden = true;
      return;
    }
    var title = unlock.querySelector('[data-mr-set-unlock-title]');
    var description = unlock.querySelector('[data-mr-set-unlock-description]');
    if (title) title.textContent = rewards.length > 1 ? 'Two rewards unlocked' : rewards[0].title;
    if (description) description.textContent = rewards.map(function (reward) { return reward.description; }).join(' ');
    unlock.hidden = false;
    if (!reducedMotion) {
      requestAnimationFrame(function () {
        dialog.classList.add('is-celebrating');
      });
      window.setTimeout(function () { dialog.classList.remove('is-celebrating'); }, 1200);
    }
  }

  function getUnlockedRewards(previousState, currentState, previousTotal, currentTotal, shippingThreshold) {
    var rewards = [];
    if (currentState.tierIndex > previousState.tierIndex && currentState.currentTier) {
      rewards.push({
        title: currentState.currentTier.percent + '% off unlocked',
        description: 'Your cart now qualifies for ' + currentState.currentTier.percent + '% off the set.'
      });
    }
    if (shippingThreshold > 0 && previousTotal < shippingThreshold && currentTotal >= shippingThreshold) {
      rewards.push({
        title: 'Free shipping unlocked',
        description: 'Your cart has reached the free shipping goal.'
      });
    }
    return rewards;
  }

  function getFreeShippingThreshold(root) {
    if (root.dataset.freeShippingEnabled !== 'true') return 0;
    var baseThreshold = Math.max(0, Number(root.dataset.freeShippingThreshold) || 0);
    var currencyRate = window.Shopify && window.Shopify.currency
      ? Number(window.Shopify.currency.rate) || 1
      : 1;
    return Math.round(baseThreshold * currencyRate);
  }

  function syncProductCartState(tabs, items) {
    var quantities = {};
    items.forEach(function (item) {
      var productId = String(item.product_id || '');
      quantities[productId] = (quantities[productId] || 0) + (Number(item.quantity) || 0);
    });

    tabs.forEach(function (tab) {
      var quantity = quantities[String(tab.dataset.productId || '')] || 0;
      var added = quantity > 0;
      tab.dataset.cartQuantity = String(quantity);
      tab.classList.toggle('is-added', added);
      var state = tab.querySelector('[data-mr-set-tab-state]');
      if (state) {
        state.textContent = added
          ? 'Added'
          : tab.classList.contains('is-active') ? 'Selected' : 'Choose';
      }
    });
  }

  function fetchCart() {
    var base = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    if (base.charAt(base.length - 1) !== '/') base += '/';
    return window.fetch(base + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to refresh cart.');
      return response.json();
    });
  }

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || 'USD'
      }).format(Math.max(0, Number(cents) || 0) / 100);
    } catch (error) {
      return '$' + (Math.max(0, Number(cents) || 0) / 100).toFixed(2);
    }
  }

  function closeDialog(dialog) {
    if (!dialog || !dialog.open) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  }

  function findByData(root, keyOne, valueOne, keyTwo, valueTwo) {
    return Array.from(root.querySelectorAll('[data-' + camelToKebab(keyOne) + ']')).find(function (node) {
      var firstMatches = String(node.dataset[keyOne] || '') === String(valueOne || '');
      var secondMatches = !keyTwo || String(node.dataset[keyTwo] || '') === String(valueTwo || '');
      return firstMatches && secondMatches;
    }) || null;
  }

  function dispatch(node, type) {
    node.dispatchEvent(new Event(type, { bubbles: true }));
  }

  function nextPaint() {
    return new Promise(function (resolve) {
      requestAnimationFrame(function () {
        requestAnimationFrame(resolve);
      });
    });
  }

  function camelToKebab(value) {
    return value.replace(/[A-Z]/g, function (letter) { return '-' + letter.toLowerCase(); });
  }

  function escapeId(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return String(value).replace(/([^a-zA-Z0-9_-])/g, '\\$1');
  }

  window.MRSetBuilderInit = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
